/*
 * @Author: 肖玲
 * @Date: 2023-03-01 13:46:53
 * @LastEditTime: 2023-03-02 11:48:09
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\flow-direction-data-query\modules\flowSatementRouter.js
 * 流向申述路由
 */
const flowSatementRouter = [
  // 流向申诉
  {
    path: '/flowSystem/flow-appeal-list',
    name: 'flowSystemFlowAppealList',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics4" */
      //   '../views/flowSystem/FlowAppealList.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystemStatistics4" */
        '@/views/butterfly-flow-system/flow-direction-data-query/flow-satement/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '流向申诉', //二级菜单
      title: '流向申诉',
    },
  },
  // 流向申诉 发起申诉
  {
    path: '/flowSystem/flow-appeal-list/add-detail',
    name: 'flowSystemFlowAppealListAddDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics4" */
      //   '../views/flowSystem/FlowAppealListAddDetail.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystemStatistics4" */
        '@/views/butterfly-flow-system/flow-direction-data-query/flow-satement/InitiateStatement.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '流向申诉', //二级菜单
      title: '发起流向申诉',
      breadcrumb: [
        {
          title: '流向申诉',
          name: 'flowSystemFlowAppealList',
        },
      ],
    },
  },
  // 流向申诉 导出厂家申诉
  {
    path: '/flowSystem/flow-appeal-export-manufacturer',
    name: 'flowSystemFlowAppealExportManufacturer',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics4" */
      //   '../views/flowSystem/FlowAppealExportManufacturer.vue'
      // ), 待删除文件
      import(
        /*webpackChunkName:"flowSystemStatistics4" */
        '@/views/butterfly-flow-system/flow-direction-data-query/flow-satement/Export.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '流向申诉', //二级菜单
      title: '导出厂家申诉',
      breadcrumb: [
        {
          title: '流向申诉',
          name: 'flowSystemFlowAppealList',
        },
      ],
    },
  },
  // 流向申诉 流向申诉详情
  {
    path: '/flowSystem/flow-appeal-detail/:flow_appeal_id',
    name: 'flowSystemFlowAppealDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics4" */
      //   '../views/flowSystem/FlowAppealDetail.vue'
      // ), 待删除文件
      import(
        /*webpackChunkName:"flowSystemStatistics4" */
        '@/views/butterfly-flow-system/flow-direction-data-query/flow-satement/Detail.vue'
      ),  //新迁移文件
    meta: {
      SecondaryMenu: '流向申诉', //二级菜单
      title: '流向申诉详情',
      breadcrumb: [
        {
          title: '流向申诉',
          name: 'flowSystemFlowAppealList',
        },
      ],
    },
  },
]
export default flowSatementRouter
